export const NAMESPACE = {
  SECURITY_PREVIEW_DOCUMENT:
    'File can not be previewed due to security reasons',
  REFETCHING_DOCUMENTS: 'Update Security Status',
  SCAN_IN_PROGRESS_DOCUMENT_TOOLTIP:
    'Document is being scanned and will be available shortly',
  READY_DOCUMENT_TOOLTIP: 'Available to view',
  BLOCKED_DOCUMENT_TOOLTIP: 'Preview not allowed for Security Reasons',
  PENDING_DOCUMENT_TOOLTIP: 'Pending Document Upload',
  ERROR_IN_SCAN_DOCUMENT_TOOLTIP:
    'File scan could not be completed. Please contact your system administrator',
  OUTBOUND_CALL: 'Outbound Call',
  INVALID_SSN_NUMBER: 'Invalid SSN number',
  INVALID_PHONE_NUMBER: 'Invalid phone number',
  INVALID_NPI: 'Invalid NPI',
  INVALID_DEA: 'Invalid DEA',
  ACTIONS: 'Actions',
  MORE_ACTIONS: 'More actions',
  CONTENT_EXCEED_CHAR_LIMIT: 'Content exceeds maximum length of ',
  CHARACTERS: ' characters',
  FILTER_BY: 'Filter By',
  IN_PROGRESS: 'In Progress',
  CLEAR: 'Clear',
  SEARCH: 'Search',
  INVALID_LOGIN_MSG: 'Invalid email or password.',
  APPLY_FILTER: ' Apply Filter',
  VALID_EMAIL_ADDRESS: 'Please enter a valid email address',
  APPLY: 'Apply',
  DRAFT_DOCUMENT: 'Draft document cannot be enabled.',
  DRAFT_TEMPLATE: 'Draft template cannot be enabled.',
  PASSWORD_DO_NOT_MATCH_MSG: 'Password do not match.',
  PASSWORD_CONTAINS_NAME_MSG:
    'Cannot contain all or part of the user’s account name.',
  INVALID_LENGTH_MSG: 'Password must be between 8 to 14 characters',
  INVALID_SPECIAL_CHAR_MSG: 'Must contain 1 special character [!@#$%^&*]',
  INVALID_NUMERIC_DIGIT_MSG: 'Must contain 1 number (0-9)',
  INVALID_LOWER_CASE_MSG: 'Must contain 1 lowercase character (a to z)',
  INVALID_UPPER_CASE_MSG: 'Must contain 1 uppercase character (A to Z)',
  PASSWORD_VALIDATION_STRING: ' Password must have',
  PASSWORD_REQUIRED_MSG: 'This field is required.',
  REQUIRED_FIELD: 'This is a required field',
  EXPORT: 'Export',
  DOWNLOAD_TEMPLATE: 'Download Template',
  ADD_NEW: 'Add New',
  NO_OPTIONS: 'No Options',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  ADD: 'Add',
  IMPORT_FILE: 'Import File',
  IMPORT: 'Import',
  ZIPCODE_VALIDATION_MSG:
    'Please enter a valid ZIP code in the format 12345 or 12345-6789.',
  ROWS: {
    FIVE: '5 Rows',
    TEN: '10 Rows',
    TWENTY_FIVE: '25 Rows',
    FIFTY: '50 Rows',
    HUNDRED: '100 Rows',
  },
  COLLAPSE: 'Collapse',
  VIEW: 'view',
  EDIT: 'edit',
  NEW_ADD: 'add',
  LOGOUT: 'Logout',
  REDACTED: '****',
  REQUIRED: 'Required',
  IMAGE_TYPE: 'image',
  UPLOAD_FILES: 'Upload files',
  NO_RECORDS_FOUND: 'No results found',
  UPLOAD: 'Upload',
  CLOSE: 'Close',
  DOWNLOAD_ALL: 'Download All',
  EDIT_BUTTON: 'Edit',
  VIEW_DOCUMENTS: 'View Documents',
  HEADER_FOR_UPLOAD: 'Select and upload the files of your choice',
  DOWNLOAD_ERROR: 'Error during download:',
  REMOVED: 'REMOVED',
  ZIP_FILE: 'zip_file',
  PREVIEW: 'preview',
  DELETE: 'Delete',
  NO_FILES_FOUND: 'No files uploaded for this record',
  REQUIRED_LOWERCASE: 'required',
  NO_DATA_FOUND: 'No result found.',
  IS_REQUIRED: 'is required',
  IS_NOT_PRESENT: 'is not present',
  AT_TILE: ' at tile ',
  EITHER_REMOVE_TILE_OR_ADD_A_VALUE: '. Either remove tile or add a value.',
  IS_NOT_PRESENT_AT_TILE: ' is not present at tile ',
  MULTI: 'multi',
  SINGLE: 'single',
  ENTITY_MISMATCH_MSG: 'Recipient placeholders should be from same entity',
  DELETE_FILE: 'Are you sure you want to permanently delete this file?',
  ADD_COLUMN: 'Add Column',
  RESTORE_DEFAULT: 'Restore Default',
  INVALID_FILE_TYPE_MSG:
    'Invalid file type. Supported formats: JPG, PNG, PDF, DOC, DOCX, DOCM, XLS, XLSX, XLSM, TXT, CSV',
  INVALID_FILE_SIGNATURE_TOASTER_MSG:
    'Invalid or corrupted file. Please try another file',
  INVALID_FILE_SIGNATURE_MSG: 'Invalid or corrupted file.',
  SELECT: 'Select',
  INVALID_RESPONSE: 'Invalid response',
  FACILITY_INFORMATION: 'Search Facility Information',
  AE_PC_REVIEW: 'AE/PC Review',
  SUCCESS: 'success',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  INTAKE_CDS_REQUEST: 'Intake CDS Request',
  BLANK: 'blank',
  NOT_BLANK: 'notBlank',
  EXTENSIONS_NOT_ALLOWED_IN_FILENAME:
    'Extensions not allowed in the file name.',
  INVALID_FILE_NAME_MULTIPLE_DOTS:
    'Remove extra periods (.) from the file name and try again.',
  INVALID_FILE_NAME_CHARACTERS: 'File name contains invalid characters.',
  UPLOAD_API_ERROR: 'File could not be uploaded. Please try again.',
}

export const DIALOG_NAMESPACE = {
  SESSION_EXPIRY: 'sessionExpiry',
  WARNING: 'warning',
  SESSION_EXPIRY_MESSAGE: 'Your session is about to expire',
}

export const CONFIRM_DIALOG_NAMESPACE = {
  CONFIRM_REASON_LABEL: 'If yes, please put the reason here',
  REASON_ATTACHMENT_REQUIRED: 'Reason for attaching the document is required.',
  SUBMIT: 'Submit',
  WORDS_50: '50 Words',
  REASON_REQUIRED: 'Reason is required',
  REASON_LIMIT: 'Reason cannot exceed 50 words',
  DISCARD_FAX_CONFIRMATION_MESSAGE:
    'Are you sure you want to discard this fax?',
  CANCEL: 'Cancel',
}

export const VARCHAR_WITH_50_CHAR_LIMIT_REGEX = /^[^\n]{0,50}$/

export const STEPPER_STATES = {
  PENDING: 'pending',
  INPROGRESS: 'inProgress',
  COMPLETED: 'completed',
}

export const STEPPER_COLORS = {
  INPROGRESS: '#0096C7',
  COMPLETED: '#0B8558',
  PENDING: '#6B7280',
}

export const STEPPER_DIRECTIONS = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
}

export enum STEPPER_DIRECTIONS_ENUM {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export const COLOR_PICKER_MODES = {
  HEX: 'HEX',
  RGBA: 'RGBA',
}

export const CONFIRMATION_BOX_ICON = {
  ATTACHMENT: 'attachment',
}

export const CK_EDITOR = {
  IMPORT_FROM_WORD: 'Import From Word',
  RENDER_ERROR: 'Error rendering Word document:',
  UPLOAD_VALID_DOCUMENT: 'Invalid file type. Please upload a .docx file',
}

export const ATTACHMENT_FIELD_OPTIONS = {
  PREVIEW: 'Preview',
  COPY: 'Copy',
  DOWNLOAD: 'Download',
  PRINT: 'Print',
  PREVIEW_LOWERCASE: 'preview',
  DOWNLOAD_LOWERCASE: 'download',
}

export const PAGINATION_NAMESPACE = {
  ROWS: 'Rows',
  SHOW: 'Show:',
}

export const PROFILE_FLYOUT = {
  DISPLAY_SETTINGS: 'Display Settings',
  COMFY: 'Comfy',
  COMPACT: 'Compact',
  LOGOUT: 'Logout',
  VIEW_DETAILS: 'View Details',
}

export const AGENT_STATUS = {
  AVAILABLE: 'Available',
  OFFLINE: 'Offline',
  OUTBOUND: 'Outbound',
  REPORTS: 'Reports',
  SYSTEM_DOWN: 'System Down',
  LUNCH: 'Lunch',
  BREAK: 'Break',
}
